<template>
  <label class="radio --classic" :class="{'opacity-50':!!disabled}">
    <input type="radio"
           :checked="checked"
           :value="value"
           :disabled="disabled"
           @change="$emit('change',value)">
    <span class="radio__label" :class="{checked}">
        <slot></slot>
      </span>
  </label>
</template>

<script>
export default {
  name: "BaseRadio",
  model: {
    prop: 'modelValue',
    event: 'change'
  },
  props: {
    value: {
      type: [Number, String, Boolean],
      required: true
    },
    name: {
      type: String
    },
    modelValue: {
      default: ""
    },
    disabled: {
      type: Boolean
    }
  },
  computed: {
    checked() {
      return this.modelValue == this.value
    }
  }
}
</script>

<style scoped lang="scss">
.radio {
  input {
    visibility: hidden;
    width: 0;
    height: 0;
  }

  &.--classic {
    @apply flex;
    min-height: 2rem;

    + .--classic {
      @apply mt-4;
    }

    .radio__label {
      @apply text-text-secondary text-sm relative pl-12 cursor-pointer tracking-tight leading-normal;

      &:before {
        @apply left-0 top-0 absolute h-8 w-8 bg-block rounded-full border border-border shadow-input;
        content: '';
      }

      &:after {
        @apply absolute bg-red w-4 h-4 left-2 top-2 rounded-full opacity-0;
        content: '';
      }

      &.checked:after {
        @apply opacity-100;
      }
    }
  }

  &.--buttons {
    @apply flex;
    &:first-of-type .radio__label {
      @apply rounded-bl rounded-tl;
    }

    &:last-of-type .radio__label {
      @apply rounded-br rounded-tr;
    }

    .radio__label {
      @apply border border-border text-2sm text-text-label bg-block px-6 py-4 transition duration-200 cursor-pointer;

      &:hover {
        @apply text-white;
        border-color: #5B758D;
        background: #5B758D;
      }

      &.checked {
        @apply text-white;
        border-color: #5B758D;
        background: #5B758D;
      }
    }
  }
}
</style>